import { render, staticRenderFns } from "./AppDoubleBarChart.vue?vue&type=template&id=408fa012&"
import script from "./AppDoubleBarChart.vue?vue&type=script&lang=js&"
export * from "./AppDoubleBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports